(function () {
  function initFooter(root) {
    if (!root) return;
    root.querySelectorAll('.lp-footer__col--collapsible .lp-footer__toggle').forEach(function (btn) {
      if (btn.dataset.lpFooterBound) return;
      btn.dataset.lpFooterBound = 'true';
      btn.addEventListener('click', function () {
        var col = btn.closest('.lp-footer__col--collapsible');
        if (!col) return;
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initAllFooters() {
    document.querySelectorAll('.lp-footer').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFooters);
  } else {
    initAllFooters();
  }

  document.addEventListener('shopify:section:load', initAllFooters);
  document.addEventListener('shopify:section:reorder', initAllFooters);
})();
